module.exports = "/_next/static/resources/photo-3-f8dc3b06784584f1f1b578b749006a13.jpg";